export const API_BASE =
  process.env.REACT_APP_API_BASE || 'https://srvr.umatrip.uz/api/v1';

export const API_KEY = process.env.REACT_APP_API_KEY || '';

